'use strict';

angular.module('utils').factory('OCLogUtil', function(ClinicConfig) {
  const self = {
    // Rollbar: https://docs.rollbar.com/v1.0.0/docs/javascript
    rollbar: {
      log: function(message, level, extra) {
        if (!['critical', 'error', 'warning', 'info', 'debug'].includes(level)) {
          level = 'error';
        }

        const consoleLevel = {
          critical: 'error',
          error: 'error',
          warning: 'warn',
          info: 'info',
          debug: 'debug',
        }[level] || 'error';

        if (ClinicConfig.ENV === 'development') {
          console[consoleLevel](message, extra);
        }

        window.Rollbar?.[level]?.(message, extra);
      },

      error: function(error, extra) {
        self.rollbar.log(error, 'error', extra);
      },

      info: function(message, extra) {
        self.rollbar.log(message, 'info', extra);
      },

      debug: function(message, extra) {
        self.rollbar.log(message, 'debug', extra);
      },

      httpResponseError: function(error, response) {
        const extra = _.pick(response || {}, ['status', 'data']);
        extra.config = _.pick(response?.config, ['data', 'headers', 'method', 'url']);
        extra.referrer = document.referrer || 'Direct';
        self.rollbar.error(error, extra);
      },
    },
  };

  return self;
});
